'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'list';
var width = 512;
var height = 512;
var aliases = ["list-squares"];
var unicode = 'f03a';
var svgPathData = 'M32 64l0 64 64 0 0-64L32 64zM16 48l16 0 64 0 16 0 0 16 0 64 0 16-16 0-64 0-16 0 0-16 0-64 0-16zM176 88l320 0 8 0 0 16-8 0-320 0-8 0 0-16 8 0zm0 160l320 0 8 0 0 16-8 0-320 0-8 0 0-16 8 0zm0 160l320 0 8 0 0 16-8 0-320 0-8 0 0-16 8 0zM96 224l-64 0 0 64 64 0 0-64zM32 208l64 0 16 0 0 16 0 64 0 16-16 0-64 0-16 0 0-16 0-64 0-16 16 0zm0 176l0 64 64 0 0-64-64 0zM16 368l16 0 64 0 16 0 0 16 0 64 0 16-16 0-64 0-16 0 0-16 0-64 0-16z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faList = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;